import { render, staticRenderFns } from "./OrgSelector.vue?vue&type=template&id=ba655dde&scoped=true"
import script from "./OrgSelector.vue?vue&type=script&lang=js"
export * from "./OrgSelector.vue?vue&type=script&lang=js"
import style0 from "./OrgSelector.vue?vue&type=style&index=0&id=ba655dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba655dde",
  null
  
)

export default component.exports